import styled from 'styled-components';
import { colors } from 'styles/colors';

export const HealthUnitsInfoContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 169px);
  gap: 12px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, minmax(0, 169px));
  }
`;

export const UnitCardContainer = styled.div<{ backgroundColor: string, disabledCard: boolean }>`
  max-width: 169px;
  height: 166px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid ${colors.stroke['soft-200']};
  border-radius: 12px;
  background-color: ${({ backgroundColor, disabledCard }) => (disabledCard ? colors.bg['weak-100'] : backgroundColor)};
  padding: 8px 16px;

  ${({ disabledCard }) => (disabledCard ? '' : `
    padding-top: 24px;
  `)}

  & > button {
    margin-top: auto;
  }

  & > h5 {
    margin: 0;
    margin-bottom: 4px;
    font-weight: 700;
    font-size: 20px;
    line-height: 100%;
    color: ${colors.text['main-900']};
    text-align: center;
  }

  & > h6 {
    margin: 0;
    font-weight: 400;
    font-size: 12px;
    line-height: 120%;
    color: ${colors.text['main-900']};
    text-align: center;
    max-width: 105px;
  }
`;

export const UnitCardIconContainer = styled.div<{ backgroundColor: string, disabled: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  background-color: ${({ backgroundColor, disabled }) => (disabled ? colors.icon['disabled-300'] : backgroundColor)};

  margin-bottom: 16px;
`;
